import { node } from "~/util/dom";
import createSDSIcon from "./icon";
import { EMPTY_SYMBOL_24 } from "@sznds/icons";

interface IContextMenuItemProps {
	icon: HTMLElement;
	rightIcon: HTMLElement;
	text: string;
	onClick: (event: PointerEvent) => void;
	destructive: boolean;
}

const DEFAULT_PROPS: IContextMenuItemProps = {
	icon: null,
	rightIcon: null,
	text: "",
	onClick: null,
	destructive: false,
};

export default class ContextMenuItem {
	#container: HTMLButtonElement;

	#props: IContextMenuItemProps;

	constructor(props: Partial<IContextMenuItemProps> & Pick<IContextMenuItemProps, "text">) {
		this.#props = {
			...DEFAULT_PROPS,
			...props,
		};
		this.#container = node("button", { type: "button", className: `ui-contextmenuitem ${this.#props.destructive ? "ui-contextmenuitem--destructive" : ""}` });
		this.#container.setAttribute("role", "menuitem");
		this.#props.onClick && this.#container.addEventListener("click", this.#props.onClick, false);

		if (props.icon) {
			props.icon.classList.add("ui-contextmenuitem__icon");
			this.#container.appendChild(props.icon);
		} else {
			this.#container.appendChild(createSDSIcon({ symbol: EMPTY_SYMBOL_24, className: "ui-contextmenuitem__icon" }));
		}

		this.#container.appendChild(node("span", { className: "ui-contextmenuitem__text" }, props.text));

		if (props.rightIcon) {
			props.rightIcon.classList.add("ui-contextmenuitem__icon");
			this.#container.appendChild(props.rightIcon);
		}
	}

	destroy() {
		this.#props.onClick && this.#container.removeEventListener("click", this.#props.onClick, false);
	}

	get container() {
		return this.#container;
	}
}
